class systemParamsCtrl {
    constructor($rootScope, $scope) {
        // 初始化表单数据
        // 用户信息
        const { userInfo } = $rootScope
        // 存储页面信息
        $scope.pageState = {
            idToken: $rootScope.idToken,
            userInfo,
        }
    }
}

systemParamsCtrl.$inject = ['$rootScope', '$scope']
export default systemParamsCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/systemParams/systemParamsCtrl.js